<router-outlet></router-outlet>

<footer class="tw-text-center tw-my-12">
  <div bitTypography="body2">&copy; {{ year }} MavenInject</div>
  <div bitTypography="body2">Version {{ version }}</div>
</footer>
